export enum HistoryLogAction {
  Create = 0,
  Update = 1,
  Delete = 2,
  Restore = 3,
}

export const HistoryLogActionLabel = {
  [HistoryLogAction.Create]: "create",
  [HistoryLogAction.Update]: "update",
  [HistoryLogAction.Delete]: "delete",
  [HistoryLogAction.Restore]: "restore",
};

export const TranslationFieldProperty = {
  Label: "fieldLabel",
  Required: "validationErrorText",
  Placeholder: "placeholder",
  Values: "optionLabelPlaceholder",
};

export enum HistoryEntity {
  FormTranslation = "FormTranslation",
  FormProperty = "FormProperty",
  EditableByStatus = "EditableByStatus",
  FormPropertyValue = "FormPropertyValue",
  UserAssignment = "UserAssignment",
  Permission = "Permission",
  ApprovalWorkFlowApprover = "Approver",
  DeleteWorkFlowApprover = "DeleteWorkFlowApprover",
  UserReplacementHistory = "UserReplacementHistoryItem",
}
